import React, { useState } from 'react';
import quote from '../assets/Frame.png';
import './UserInsight.css';

const UserInsights = () => {
  const [expandedIds, setExpandedIds] = useState([]);

  const testimonials = [
    {
      id: 1,
      text: "We have been operating for over an go providin top-notch services to our is a clients and build strong track record in the industry.We have been operating in for over a decad ...",
      author: "Albert Flores",
      location: "Delhi"
    },
    {
      id: 2,
      text: "We have been operating for over an go providin top-notch services to our is a clients and build strong track record in the industry.We have been operating in for over a decad ...",
      author: "Albert Flores",
      location: "Delhi"
    },
    {
      id: 3,
      text: "We have been operating for over an go providin top-notch services to our is a clients and build strong track record in the industry.We have been operating in for over a decad ...",
      author: "Albert Flores",
      location: "Delhi"
    },
    {
      id: 4,
      text: "We have been operating for over an go providin top-notch services to our is a clients and build strong track record in the industry.We have been operating in for over a decad ...",
      author: "Albert Flores",
      location: "Delhi"
    }
  ];

  const toggleReadMore = (id) => {
    setExpandedIds(prev => 
      prev.includes(id) 
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  const truncateText = (text, id) => {
    if (expandedIds.includes(id)) {
      return text;
    }
    return text.length > 100 ? `${text.substring(0, 100)}...` : text;
  };

  return (
    <div className="user-insights-container">
      <div className="sectiontitle">User <span>Insights</span></div>
      
      <div className="testimonial-grid">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="quote-icon">
              <img src={quote} alt="Quote Icon" />
            </div>

            <p className="testimonial-text">
              {truncateText(testimonial.text, testimonial.id)}
              {testimonial.text.length > 100 && (
                <span 
                  className="read-more"
                  onClick={() => toggleReadMore(testimonial.id)}
                >
                  {expandedIds.includes(testimonial.id) ? 'Show Less' : 'Read More'}
                </span>
              )}
            </p>
            
            <div className="author-container">
              <div className="author-avatar"></div>
              <div className="author-info">
                <div className="author-name">{testimonial.author}</div>
                <div className="author-location">{testimonial.location}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserInsights;